<style scoped>
.employment_info_row {
	background: #EEEEEE;
	margin-bottom: 5px;
	padding: 5px;
}

.employment_info_row:hover {
	background: #DDDDDD;
}

.daycell {
	background: white;
	width: 50px;
	text-align: right;
	margin-top: -3px;
	margin-bottom: -3px;
	margin-left: 5px;
	padding: 3px;
}

.employment_notes {
	background: white;
	margin-top: 7px;
	padding: 2px;
}
</style>

<template>
	<div class="employment_info_row" @click="edit_employment_info()">
		<div>
			<div class="daycell float-right">{{ duration_as_hm(employment_info.hours_sun) }}</div>
			<div class="daycell float-right">{{ duration_as_hm(employment_info.hours_sat) }}</div>
			<div class="daycell float-right">{{ duration_as_hm(employment_info.hours_fri) }}</div>
			<div class="daycell float-right">{{ duration_as_hm(employment_info.hours_thu) }}</div>
			<div class="daycell float-right">{{ duration_as_hm(employment_info.hours_wed) }}</div>
			<div class="daycell float-right">{{ duration_as_hm(employment_info.hours_tue) }}</div>
			<div class="daycell float-right">{{ duration_as_hm(employment_info.hours_mon) }}</div>
			<div class="float-none">
				<span>Employment info</span>
				<span> from {{ start_date }}</span>
				<span v-if="employment_info.end_date"> until {{ end_date }}</span>
				<span>, {{ employment_info.pay_cycle_desc }} ({{ sal_hours }} hours * {{ employment_info.currency_symbol }}{{ employment_info.hourly_rate }}/hour)</span>
				<span> @ {{ employment_info.client_utilisation }}% utilisation</span>
			</div>
		</div>
		<div v-if="employment_info.notes != ''" class="employment_notes">
			{{ employment_info.notes }}
		</div>
	</div>
</template>

<script>
import moment from 'moment';

export default {
	props: {
		employment_info: {
			type: Object,
			default: null
		},
		popup_editors: { // when used in the desktop app, we want to popup a new window so Omnis can catch this.
			type: Boolean,
			default: false
		},
	},
	computed: {
		start_date() {
			return moment(this.employment_info.start_date).format("DD MMMM YYYY");
		},
		end_date() {
			if (this.employment_info.end_date) {
				return moment(this.employment_info.end_date).format("DD MMMM YYYY");
			} else {
				return '';
			}
		},
		sal_hours() {
			return this.duration_as_hm(this.employment_info.salary_minutes / 60.0);
		}
	},
	methods: {
		duration_as_hm(hours) {
			let hm;
			let h = Math.floor(hours);
			let m = Math.round(60 * (hours - h))
			if (m < 10) {
				hm = h + ":0" + m;
			} else {
				hm = h + ":" + m;
			}
			return hm;
		},
		edit_employment_info() {
			if (this.popup_editors) {
				window.open('/desktop/addressbook/' + this.employment_info.addressbook_id + '/payroll_header/' + this.employment_info.payroll_header_id + '/employmentinfo/' + this.employment_info.id)
			} else {
				// route to edit URL once we implement the web interface for this
			}
		}
	}
}
</script>
